import APIClient from '@/shared/http/clients/api'

const resourceName = 'expertroutesent'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const SearchPaging = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const Search = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search`, data, config)
const SendEmail = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/sendmail`, data, config)

const ExpertRouteSentRepository = {

  Search,
  SearchPaging,
  SendEmail
}

export default ExpertRouteSentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/expertroutes/expertroutes.js